export const getTextDirection = direction => {
    switch (direction) {
        case 'protest': return 'Протестная активность';
        case 'news': return 'Новость';
        case 'creative': return 'Креатив';
        default: return 'Протестная активность';
    }
}
